import { Component, OnInit } from '@angular/core';
import { Campaign } from '@app/_services/Instore'; // './././_services/Instore';
import * as XLSX from 'xlsx';
import {Sort} from '@angular/material/sort';
import { ExcelService } from '@app/_services/excel.service';

@Component({
  selector: 'app-bulkcampaign',
  templateUrl: './bulkcampaign.component.html',
  styleUrls: ['./bulkcampaign.component.css']
})
export class BulkcampaignComponent implements OnInit {
  importCampaign: Campaign[] = [];
  exportCampaign: Campaign[] = [];
  filterString = "";

  page = 1;
  pageSize = 30;

  constructor(private excelSrv: ExcelService) { }

  ngOnInit(): void {
    //this.refreshRecognitions()
  }
  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      const data = <any[]>this.excelSrv.importFromFile(bstr);

      const header: string[] = Object.getOwnPropertyNames(new Campaign());
      const importedData = data.slice(1, -1);

      this.importCampaign = importedData.map(arr => {
        const obj = {};
        for (let i = 0; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
        }
        return <Campaign>obj;
      })

      console.log("Reports----"+JSON.stringify(this.importCampaign))

    };
    reader.readAsBinaryString(target.files[0]);

  }

  exportData(tableId: string) {
    this.excelSrv.exportToFile("instore", tableId);
  }

}